const styles = theme => ({
  phoneLabel: {
    left: 54,
    zIndex: 0,
  },
  phoneErrorText: {
    paddingLeft: 54,
    display: "flex",
    alignItems: "center",
  },
  infoCircle: {
    color: theme.palette.error.main,
    marginLeft: theme.spacing(1),
  },
})

export default styles
